import { atBqnTarget } from "common/api";
import { getKeysSeries, parseDate } from "../utils";

export const parseStatsBtaData = (response, beginRange, endRange) => {
  const [header, ...rows] = response.trim(/\s/).split("\n");
  const keysSeries = getKeysSeries(header);
  const newKeys = ["time", ...keysSeries];
  const items = rows.reduce(
    (acc, value) => {
      const [timeAt, ...attrs] = value.split(/\s+/);
      const time = parseDate(timeAt);
      if (beginRange < time && time < endRange) {
        const item = attrs.reduce(
          (accItem, valueItem, index) => {
            accItem[newKeys[index + 1]] = valueItem === "n/a" ? null : Number(valueItem);
            return accItem;
          },
          { time }
        );
        acc.push(item);
      }
      return acc;
    }, []);

  return { fields: keysSeries, items };
};


// The data of the BQN selected in the header, or of the whole cluster. The
// response of "show license" keeps its BQN column when one BQN is asked for.

export const btaStatsRetrieval = ({ lines, mode, bqnId }) =>
  ifCl.run(atBqnTarget(`show statistics bta lines ${lines}`, mode, bqnId));

export const licenseRetrieval = (mode, bqnId) =>
  ifCl.run(atBqnTarget("show license", mode, bqnId));
